document.addEventListener("DOMContentLoaded", () => {

  const tileQuantityButtons = document.querySelectorAll('.product-tile-quantity__button');
  tileQuantityButtons.forEach(tileQuantityButton => tileQuantityButton.addEventListener('click', () => productQuantityButtonClicked(event)));

  function productQuantityButtonClicked(event) {
    const target = event.target || event.srcElement;
    const productId = target.getAttribute("data-product-id");
    let productQuantityInput = document.getElementById(`product-tile-quantity-${productId}`);
    let existingQuantity = parseInt(productQuantityInput.value);
    const minQuantity = parseInt(productQuantityInput.getAttribute("min"));
    const stepQuantity = parseInt(productQuantityInput.getAttribute("step"));

    let newQuantity = existingQuantity;

    if(target.getAttribute("name") === "minus") {
      newQuantity = newQuantity - stepQuantity;

      if(newQuantity < minQuantity) {
        newQuantity = minQuantity;
      }

      productQuantityInput.value = newQuantity;

    } else if(target.getAttribute("name") === "plus") { 
      newQuantity = newQuantity + stepQuantity;

      productQuantityInput.value = newQuantity;
    }

  }


});